<script setup lang="ts">
import { useFormValidation } from "../../../../composables/useFormValidation";
import { required } from "../../../../utils/validation";
import TextInput from "../../../../components/ui/form/TextInput.vue";
import CheckInput from "../../../../components/ui/form/CheckInput.vue";
import { api } from "../../../../api/Api";
import Toast from "../../../../services/Toast";
import { computed, onMounted, ref, watch, watchEffect } from "vue";
import { Permission } from "../../../../types/auth";
import IconComponent from "../../../../components/ui/common/IconComponent.vue";
import ModalFormTemplate from "../../../../components/ui/Templates/ModalFormTemplate.vue";
import FileUpload from "../../../../components/ui/form/FileUpload.vue";
import Buttons from "../../../../components/ui/form/Buttons.vue";

const props = defineProps<{
  data?: any | null;
  variant?: any | null;
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus";
  title: string | null;
  endPoint: string;
  item?: any;
  permissions?: Permission[];
  listCreateName?: string;
}>();

const emit = defineEmits<{
  (e: "save", data: any, photo: string): void;
  (e: "assign", data: any, photo: string): void;
  (e: "add", data: any): void;
  (e: "close"): void;
}>();


const { fields, formData, setFieldRules, validateForm, resetForm, setFormData } =
  useFormValidation({
    id: props.data?.id || '',
    variants_id: props.data?.variants_id || props.data?.variants || props.variant?.id,
    variant_lists_id: props.data?.variant_lists_id || '',
    variant: props.data?.variant || props.data?.variant_names || props.variant?.name,
    items_id: props.data?.items_id || props.item?.id ||  props.variant?.items_id,
    name: props.data?.name || props.listCreateName || "",
    photo: props.data?.photo || "",
    code: props.data?.code || "",
    active: props.data?.active || true,
    uid: props.data?.uid || "",
  });

  const isReadOnly = ref(true) ;
watchEffect(() => {
  if (props.mode == "create" || props.mode == "edit") {
    isReadOnly.value = false;
  } else {
    isReadOnly.value = true;
  }
  if (props.variant && props.mode == "create") {
    fields.value.variants_id.value = props.variant?.id;
    fields.value.variant.value = props.variant?.name;
  } /*else {
    console.log('watcheffect daaa prop', props.data)
    if (props.data)
      setFormData(props.data)
  }*/
});


//setFieldRules("variants_id", [required("Variant is required")]);
setFieldRules("code", [required("Code is required")]);
setFieldRules("name", [required("Name is required")]);


const handleSubmit = async (close: boolean, newRecord: boolean) => {
  console.log("formData => submit", formData.value);
  console.log("fields => submit", fields.value);
  if (validateForm()) {
    if (formData.value.variants_id == "") {
      emit("add", formData.value);
      if (close) {
        emit("close");
      } else if (newRecord) {
        resetForm();
      }
      return;
    }
    const action = formData.value.uid != "" ? "list-update" : "list-create";
    const response = await api.post(
      (props.endPoint.slice(-1) == "/"
        ? props.endPoint
        : props.endPoint + "/") + action,
      formData.value
    );
    if (response.success == true) {
      Toast.show("saved successfully");
      emit("save", response.data, formData.value.photo);
      if (close) {
        emit("close");
      } else if (newRecord) {
        resetForm();
      } else {
        setFormData(response.data)
      }
    }
  }
};

const handleUpdatePhoto = () => {
  if (fields.value.photo.value != "") {
    emit("save", formData.value, fields.value.photo.value);
  } else {
    Toast.show("Please Upload the Photo first first");
  }
}

watch(
  () => fields.value.name.value,
  (newValue) => {
    if (newValue) {
      let code = newValue.charAt(0).toUpperCase();
      if (
        props.variant?.list?.some((item: { code: any }) => item.code === code)
      ) {
        code = newValue.substring(0, 2).toUpperCase();
      }
      fields.value.code.value = code;
    }
  }
);
const codeExists = computed(() => {
  return props.variant?.list?.some(
    (item: { code: any }) => item.code === fields.value.code.value
  );
});

onMounted(() => {
  console.log("prop => mount data", props.data);
  console.log("variant", props.variant);
  if (props.data)
    setFormData(props.data)
  console.log("formData => mount", formData.value);
});
</script>
<template>
  <ModalFormTemplate
    :data="data"
    :mode="mode"
    :title="title"
    :endPoint="endPoint"
    :perm="permissions"
    :listCreateName="listCreateName"
    :ignore-permission="true"
    :tabList="[]"
    :formData="formData"
    width="35rem"
    @save="handleSubmit"
    @close="$emit('close')"
  >
  <template #header>
    <Buttons
      v-if="mode == 'view' && fields.id.value != ''"
      icon="ImagePlus"
      caption="Update Photo & Assign"
      @click="handleUpdatePhoto" />

      <Buttons
      v-if="mode == 'view' && fields.id.value != ''"
      icon="Shapes"
      caption="Assign to Item"
      @click="$emit('assign', formData, formData.photo)" />

    </template>
    <template #form>
      <div class=" md-[500px] grid md:grid-cols-2 gap-6">
        <TextInput
          v-model="fields.variant.value"
          label="Variant name"
          placeholder="Variant name"
          :readonly="true"
          :error="fields.variants_id.touched ? fields.variants_id.error : null"
          @blur="fields.variants_id.touched = true"
        />
        <FileUpload
          v-model="fields.photo.value"
          label="Photo"
          path="item_variants"
          :error="fields.photo.touched ? fields.photo.error : null"
          @blur="fields.photo.touched = true" />
      </div>
      <div class="grid md:grid-cols-2 gap-6">

        <TextInput
          v-model="fields.name.value"
          label="Name"
          placeholder="Enter Name"
          :readonly="isReadOnly"
          :error="fields.name.touched ? fields.name.error : null"
          @blur="fields.name.touched = true"
        />


        <div class="relative">
          <TextInput
            v-model="fields.code.value"
            label="Code"
            placeholder="Enter Code"
            :readonly="isReadOnly"
            :error="fields.code.touched || codeExists ? fields.name.error : null"
            @blur="fields.code.touched = true"
            :class="{'border-red-500': codeExists}"
          />
            <IconComponent
              v-if="codeExists"
              name="TriangleAlert"
              class="absolute right-2 text-orange-500 mt-[-30px]"
              title="Code already exists, please enter a unique code"
            />
          <p v-if="codeExists" class="text-red-500 text-sm mt-1">Code already exists, please enter a unique code</p>
        </div>

        <CheckInput
          v-model="fields.active.value"
          :readonly="isReadOnly"
          label="Active"
          :error="fields.active.touched ? fields.active.error : null"
          @blur="fields.active.touched = true"
        />
      </div>
    </template>
  </ModalFormTemplate>
</template>
